<script lang="ts">
    import {link,push} from 'svelte-spa-router'
    import * as qs from 'qs';
    import * as numeral from 'numeral';
    import Header from './Header.svelte';
    import HeaderThemes from './HeaderThemes.svelte';
    import Footer from './Footer.svelte';
    import FooterThemes from './Footerthemes.svelte';
    import Clipboard from "svelte-clipboard";
    import Fa from 'svelte-fa'
    import { faLine } from '@fortawesome/free-brands-svg-icons';
    import { faSpinner,faCopy } from '@fortawesome/free-solid-svg-icons';
    import Swal from 'sweetalert2'
    

    document.body.scrollIntoView();
    let dataSetting = JSON.parse(window.localStorage.getItem('setting'))

    let loading = true
    let bnakDep = {}
    let bakList = []
    let creditwd = ""
    let isbutton = true
    let mgpchannelType = "0"

    let mgpBKList //Corepay
    let mgpBKListMulti = []

    let isGatewayCorepay = false
    let isShowBank = true
    let isShowMulti = false

    let sectionBank = true
    let sectionWallet = true

    let bankBKList = []
    let walletBKList = []
    let autobank_type = ""
    let mybankIDs = ""

    let myBankBankList = []
    let myBankWalletList = []
    let myBankAllList = []
    let bankData2 = []
    let bankData3 = []
    let bankDataAll = []
    let names;

    let dataMember
    let isMember = false

    let scactive = {
        a:'active',
        b:'',
        c:'',
    }

    let multiPayment = 0

    async function getMember() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/getmember", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            dataMember = json.payload
            isMember = true
		}
    }
    async function getBankdeposit() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/getbankdeposit", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            
            bakList = json.payload.lists
            autobank_type = json.payload.setting.autobank_type
            // names = bnakDep.bankaccountnumber
            for await (const iterator of json.payload.lists) {
                if(iterator.bank_code == 'truewallet'){
                    walletBKList.push(iterator)
                }
                if(iterator.bank_code != 'truewallet' && iterator.bank_code != 'ezpay' && iterator.bank_code != 'spay' && iterator.bank_code != 'jpay' && iterator.bank_code != 'gonepay'){
                    bankBKList.push(iterator)
                }

                if((iterator.bank_code == 'ezpay' || iterator.bank_code == 'spay' || iterator.bank_code == 'jpay' || iterator.bank_code == 'gonepay') && iterator.auto == 'O'){
                    // isGateway = false
                    mgpBKList = iterator
                    mgpBKListMulti.push(iterator)
                    if(json.payload.setting.autobank_type=='A'){
                        isShowBank = false
                        isGatewayCorepay = true
                    }else{
                        isGatewayCorepay = true
                    }
                    multiPayment += 1
                }
            }
            console.log('====CKBANK===')
            
            loading = false
		} else {

            throw new Error(json);
		}
    }
    async function getBank() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/memberbank", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            myBankAllList = json.payload
            for await (const iterator of json.payload) {
                let kk = {}
                if(iterator.bankcode=='truewallet'){
                    bankData2 = json.payload
                    myBankWalletList[iterator._id] = iterator.bankcode+" "+iterator.member_acc
                }else{
                    bankData3 = json.payload
                    myBankBankList[iterator._id] = iterator.bankcode+" "+iterator.member_acc
                    // bankDataAll[iterator._id] = iterator.bankcode+" "+iterator.member_acc
                }

                bankDataAll[iterator._id] = iterator.bankcode+" "+iterator.member_acc
                
                
                //bankList.push(kk)
            }
		}
    }

    

    async function selectBankWithdrawCorePAY() {
        if(Number(creditwd)<dataMember.dataGroup.min_deposit){
            Swal.fire({
                    heightAuto: false,
                    title: 'กรุณาฝากขั้นต่ำ '+dataMember.dataGroup.min_deposit+' บาท',
                    text: "",
                    icon: 'error',
                    confirmButtonText: 'OK' 
                })
            return
        }
        isbutton = false
        mybankIDs = ""
        let vBank = []
        
        vBank = bankDataAll 

        // alert(multiPayment)

        if(bankDataAll.length==1){
            mybankIDs = bankDataAll[0].id
            if(Number(creditwd)<50 && bankDataAll[0].bank_code == 'gpay'){
                Swal.fire({
                        heightAuto: false,
                        title: 'กรุณาฝากขั้นต่ำ 50 บาท',
                        text: "",
                        icon: 'error',
                        confirmButtonText: 'OK' 
                    })
                return
            }
            if(Number(creditwd)<20 && bankDataAll[0].bank_code == 'gpayfp'){
                Swal.fire({
                        heightAuto: false,
                        title: 'กรุณาฝากขั้นต่ำ 20 บาท',
                        text: "",
                        icon: 'error',
                        confirmButtonText: 'OK' 
                    })
                return
            }
            checkMultiPayment()
        }else{
            const { value: fruit } = await Swal.fire({
                title: 'เลือกบัญชีที่ใช้ฝาก',
                input: 'select',
                inputOptions: vBank,
                inputPlaceholder: 'เลือกบัญชีที่ใช้ฝาก',
                showCancelButton: true,
                inputValidator: (value) => {
                    return new Promise((resolve) => {
                        resolve() 
                    })
                }
            })
            //console.log(fruit)
            if (fruit) {
                // console.log(fruit)
                mybankIDs = fruit
                let goWallet = false
                for await (const iterator of myBankAllList) {
                    if(iterator._id==fruit && iterator.bankcode=='truewallet'){
                        goWallet = true
                        scactive = {
                            a:'',
                            b:'active',
                            c:'',
                        }
                    }
                }
                if(goWallet){
                    isGatewayCorepay = false
                    isShowBank = true
                    sectionBank = false
                    sectionWallet = true
                    isbutton = true
                }else{
                    if(multiPayment>=2){
                        let delGpay = false
                        let delGpayfp = false
                        for await (const element of mgpBKListMulti) {
                            if(element.bank_code=='gpay' && Number(creditwd)<50 ){
                                delGpay = true
                            }
                            if(element.bank_code=='gpayfp' && Number(creditwd)<20 ){
                                delGpayfp = true
                            }
                        }
                        if(delGpay && delGpayfp){
                            isGatewayCorepay = false
                            isShowBank = true
                            sectionBank = true
                            sectionWallet = false
                            isbutton = true
                            return
                        }
                        if(delGpay && !delGpayfp){
                            getSECPAYQRScan2()
                            return
                        }
                        if(delGpay && !delGpayfp){
                            getSECPAYQRScan()
                            return
                        }
                        checkMultiPayment()
                    }else{
                        if(mgpBKList.bank_code=='gpay' && Number(creditwd)<50 ){
                            isGatewayCorepay = false
                            isShowBank = true
                            sectionBank = true
                            sectionWallet = false
                            isbutton = true
                        }
                        else if(mgpBKList.bank_code=='gpayfp' && Number(creditwd)<5 ){
                            isGatewayCorepay = false
                            isShowBank = true
                            sectionBank = true
                            sectionWallet = false
                            isbutton = true
                        }else{
                            checkMultiPayment()
                        }
                    }
                    
                }
                // 
            }else{
                Swal.fire(`เลือกบัญชีที่ใช้ฝาก`)
                isbutton = true
            }
        }
    }
    async function checkMultiPayment() {
        if(multiPayment>=2){
            isGatewayCorepay = false
            isShowBank = false
            isShowMulti = true
        }else{
            if(mgpBKList.bank_code=='gpay'){
                getSECPAYQRScan()
            }else{
                getSECPAYQRScan2()
            }
            
        }
    }
    async function getSECPAYQRScan() {
        let bankMm
        for await (const element of mgpBKListMulti) {
            if(element.bank_code == 'gpay'){
                bankMm = element
            }
        }
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/corepayqrcode", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({
                bankid:bankMm.id,
                credit:parseInt(creditwd),
                member_acc:mybankIDs,
                channleType:mgpchannelType,
                play_url:dataSetting.member_url+"/#/history"
            })
        })
        const json = await res.json()
        if (json.statusCode==200) {
            if(bankMm.bank_code=='gpay'){
                push('/gpay/'+json.payload.txn)
            }
            else if(bankMm.bank_code=='ezpay'){
                push('/ezpay/'+json.payload.txn)
            }
            else if(bankMm.bank_code=='spay'){
                push('/spay/'+json.payload.txn)
            }else{
                window.open(json.payload.url)
                push('/history')
            }
            
		} 
        else if(json.statusCode==202){
            // isShowBank = true
            // isGateway = false
            isbutton = true
            Swal.fire({
                    heightAuto: false,
                    title: 'ไม่สามารถทำรายการได้',
                    text: json.message,
                    icon: 'error',
                    confirmButtonText: 'OK' 
                })
        }else {
            Swal.fire({
                    heightAuto: false,
                    title: 'ไม่สามารถทำรายการได้',
                    text: "กรุณาติดต่อเจ้าหน้าที่",
                    icon: 'error',
                    confirmButtonText: 'OK' 
                })
            isbutton = true
            throw new Error(json);
		}
    }
    async function getSECPAYQRScan2() {
        let bankMm
        for await (const element of mgpBKListMulti) {
            if(element.bank_code == 'gpayfp'){
                bankMm = element
            }
            if(element.bank_code == 'ezpay'){
                bankMm = element
            }
            if(element.bank_code == 'spay'){
                bankMm = element
            }
            if(element.bank_code == 'jpay'){
                bankMm = element
            }
            if(element.bank_code == 'gonepay'){
                bankMm = element
            }
        }
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/corepayqrcode", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({
                bankid:bankMm.id,
                credit:parseInt(creditwd),
                member_acc:mybankIDs,
                channleType:mgpchannelType,
                play_url:dataSetting.member_url+"/#/history"
            })
        })
        const json = await res.json()
        if (json.statusCode==200) {
            if(bankMm.bank_code=='ezpay'){
                push('/ezpay/'+json.payload.txn)
            }
            else if(bankMm.bank_code=='jpay' || bankMm.bank_code=='gonepay'){
                window.open(json.payload.slip_url,'_blank')
                Swal.fire({
                    html: `
                        <h5>หากระบบไม่เปิด หน้าชำระเงิน กรุณาคลิกที่ปุ่มด้านล่าง</h5><br />
                        <a  href="${json.payload.slip_url}" target="_blank" class="btn btn-warning btn-lg">ไปหน้าชำระเงิน</a>
                    `,
                    showCloseButton: true,
                    showCancelButton: false,
                    showConfirmButton:false,
                    focusConfirm: false
                });
                // window.location = json.payload.slip_url
                push('/history')
            }else{
                push('/spay/'+json.payload.txn)
            }
            
		} 
        else if(json.statusCode==202){
            // isShowBank = true
            // isGateway = false
            isbutton = true
            if(bankMm.bank_code=='jpay'){
                Swal.fire({
                    heightAuto: false,
                    title: 'คุณมีรายการที่รอการชำระเงิน',
                    text: 'หากต้องการเปลี่ยนแปลงยอดกรุณา ยกเลิกรายการ ก่อนหน้าก่อนทำรายการใหม่',
                    icon: 'error',
                    confirmButtonText: 'OK' 
                })
                push('/history')
            }else{
                Swal.fire({
                    heightAuto: false,
                    title: 'ไม่สามารถทำรายการได้',
                    text: json.message,
                    icon: 'error',
                    confirmButtonText: 'OK' 
                })
            }
        }else {
            Swal.fire({
                    heightAuto: false,
                    title: 'ไม่สามารถทำรายการได้',
                    text: "กรุณาติดต่อเจ้าหน้าที่",
                    icon: 'error',
                    confirmButtonText: 'OK' 
                })
            isbutton = true
            throw new Error(json);
		}
    }

    
    let textarea;
	async function copyNumber(){
		textarea.select();
		document.execCommand('copy');
	}
    getMember()
    getBankdeposit()
    getBank()
    // alertNotis()

    async function alertNotis(){
        Swal.fire({
            title: 'กรุณาตรวจสอบ "บัญชีธนาคาร" จากหน้าระบบทุกครั้ง ก่อนทำการโอนเงิน',
            confirmButtonText: "ตกลง",
            icon: "info"
        });
    }
    async function selectCh(ids){
		if(ids == 1){
            scactive = {
                a:'active',
                b:'',
                c:'',
            }
        }
        if(ids == 2){
            scactive = {
                a:'',
                b:'active',
                c:'',
            }
        }
        if(ids == 3){
            scactive = {
                a:'',
                b:'',
                c:'active',
            }
        }
	}

</script>
<div class="default-home">
<div class="row pt-2 mb-5" style="background-image: url('{dataSetting.background}'); background-size:cover; background-repeat: no-repeat; background-position: center top;">
    <Header />
    <div class="col-12 text-center mt-3" >
        <h4 style=" background: linear-gradient(135deg, rgb(0 0 0) 0%, rgb(86 80 80) 50%, rgb(131 120 120) 51%, rgb(54 50 50) 71%, rgb(0 0 0) 100%);
        box-shadow: 5px 5px 10px #000 !important;
        line-height: 30px;
        border-radius: 5px;
        padding: 2px 7px;color:gold;">เลือกช่องทางการฝากเงิน</h4>
    </div>
    <div class="col-12 text-center mt-3" >
        <div class="card mt-0 bg-black">
            <div class="card-body text-center">
                <div class="row text-white">
                    <div class="col-4 {scactive.a}" on:click={() => selectCh(1)}>
                        <span>บัญชีธนาคาร</span>
                        <div class="box-select-ch mt-2">
                            
                            <img src="./assets/icon/bankacc.png" class="img-fluid" alt="bak account">
                        </div>
                    </div>
                    <div class="col-4 {scactive.b}" on:click={() => selectCh(2)}>
                        <span>ทรูวอลเล็ท</span>
                        <div class="box-select-ch mt-2">
                            
                            <img src="./assets/icon/twalletacc.png" class="img-fluid" alt="truewallet account">
                        </div>
                    </div>
                    <div class="col-4 {scactive.c}"  on:click={() => selectCh(3)}>
                        <span>เงินดิจิทัล</span>
                        <div class="box-select-ch mt-2">
                            
                            <img src="./assets/icon/cryptoacc.png" class="img-fluid" alt="crypto currency account">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
    {#if loading}
    <div class="text-center mt-2" style="">
        <Fa icon={faSpinner} size="3x" pulse class="text-white"/>
    </div>
    {/if}
    {#if !loading}

    {#if scactive.a =='active'}
    <div class="col-12 pb-5 mt-3" style="min-height: 500px">
        <div class="card mt-0 bg-xgrey">
            <div class="card-body text-center">

                {#if isGatewayCorepay}
                <div class="card mt-2 bg-black">
                    <div class="card-body text-center pb-1">
                        <div class="row">
                            <div class="col-4"></div>
                            <div class="col-4 mb-2">
                                <svg id="Capa_1" enable-background="new 0 0 511.744 511.744"  viewBox="0 0 511.744 511.744" class="img-fluid" xmlns="http://www.w3.org/2000/svg"><g><path d="m381.239 224.164c-48.956 0-88.785-39.829-88.785-88.785s39.829-88.785 88.785-88.785 88.784 39.829 88.784 88.785-39.828 88.785-88.784 88.785z" fill="#ff7d43"/><path d="m130.506 224.164c-48.956 0-88.785-39.829-88.785-88.785s39.829-88.785 88.785-88.785 88.784 39.829 88.784 88.785-39.828 88.785-88.784 88.785z" fill="#ff9d21"/><path d="m466.744 281.636h-421.744c-24.813 0-45 20.187-45 45v140.042c0 24.813 20.187 45 45 45h421.744c24.813 0 45-20.187 45-45v-140.042c0-24.813-20.186-45-45-45z" fill="#bee75e"/><path d="m466.744 281.636h-210.872v230.042h210.872c24.813 0 45-20.187 45-45v-140.042c0-24.813-20.186-45-45-45z" fill="#00cb75"/><path clip-rule="evenodd" d="m130.506 76.593c-32.414 0-58.785 26.371-58.785 58.785s26.371 58.785 58.785 58.785 58.784-26.371 58.784-58.785-26.37-58.785-58.784-58.785z" fill="#ffde46" fill-rule="evenodd"/><path clip-rule="evenodd" d="m381.239 76.593c-32.414 0-58.785 26.371-58.785 58.785s26.371 58.785 58.785 58.785 58.784-26.371 58.784-58.785-26.37-58.785-58.784-58.785z" fill="#ffcd00" fill-rule="evenodd"/><path d="m255.872 234.691c-64.687 0-117.312-52.626-117.312-117.313s52.626-117.312 117.312-117.312 117.312 52.626 117.312 117.312c.001 64.687-52.625 117.313-117.312 117.313z" fill="#ffd321"/><path d="m255.872.065v234.626c64.687 0 117.312-52.626 117.312-117.313.001-64.687-52.625-117.313-117.312-117.313z" fill="#ff9d21"/><circle clip-rule="evenodd" cx="255.872" cy="117.378" fill="#fff36c" fill-rule="evenodd" r="87.313"/><path clip-rule="evenodd" d="m255.872 30.065v174.626c48.145 0 87.312-39.168 87.312-87.313.001-48.145-39.167-87.313-87.312-87.313z" fill="#ffde46" fill-rule="evenodd"/><path d="m271.983 346.577c-.077-.157-.158-.313-.241-.468-3.038-5.647-9.04-9.153-15.668-9.153h-.021c-6.636.007-12.639 3.527-15.667 9.186-.069.129-.136.259-.201.39l-44.053 88.452c-3.693 7.416-.676 16.421 6.739 20.114 7.418 3.694 16.422.675 20.114-6.74l6.831-13.716h52.171l6.745 13.667c2.613 5.295 7.932 8.366 13.463 8.365 2.229 0 4.492-.499 6.626-1.552 7.43-3.666 10.479-12.66 6.813-20.089zm-27.224 58.064 11.113-22.616 11.311 22.616z" fill="#fff4f4"/><path d="m394.691 339.61c-6.941-4.519-16.234-2.556-20.755 4.388l-15.771 24.228-15.979-24.471c-4.529-6.938-13.825-8.888-20.761-4.359-6.937 4.529-8.888 13.824-4.358 20.761l26.106 39.981-.1 41.185c-.021 8.284 6.68 15.017 14.964 15.037h.037c8.267 0 14.979-6.692 14.999-14.963l.101-41.236 25.905-39.795c4.52-6.944 2.555-16.236-4.388-20.756z" fill="#f6efea"/><path d="m150.054 336.955h-24.817c-4.057 0-8.059 1.719-10.856 4.657-2.621 2.753-4.144 6.539-4.144 10.343v89.127c0 8.284 6.716 15 15 15s15-6.716 15-15v-23.792c3.791-.017 7.462-.031 9.817-.031 22.411 0 40.644-18.012 40.644-40.152s-18.233-40.152-40.644-40.152zm0 50.304c-2.376 0-5.987.013-9.725.03-.018-3.938-.031-7.758-.031-10.182 0-2.101-.008-6.02-.019-10.152h9.774c5.77 0 10.644 4.649 10.644 10.152s-4.874 10.152-10.643 10.152z" fill="#fff4f4"/><path d="m224.041 167.073c6.129 4.01 11.119 6.223 16.329 7.408.517 7.815 7.003 13.999 14.949 13.999 8.284 0 15-6.716 15-15v-.774c12.172-5.067 21.338-16.081 23.64-29.777 3.009-17.892-6.66-34.045-24.059-40.195-4.366-1.544-8.724-3.15-12.936-5.082-2.293-1.052-8.104-2.804-7.018-6.227 1.731-5.455 9.579-3.313 13.14-1.536 1.051.525 2.183 1.199 3.586 2.117 8.257 5.401 19.899 1.068 22.63-8.398 1.804-6.255-.761-13.145-6.206-16.707-2.642-1.728-5.07-3.118-7.398-4.241-1.588-.819-3.409-1.62-5.427-2.324-.488-7.844-6.986-14.059-14.952-14.059-8.284 0-15 6.716-15 15v.006c-10.237 4.396-17.723 13.777-19.89 25.274-2.247 11.926 1.769 23.578 10.479 30.409 7.755 6.083 18.518 10.349 28.994 14.052 2.478.876 5.226 2.456 4.473 6.937-.482 2.868-2.953 7.733-9.155 7.774-7.783.045-9.274-.177-14.755-3.762-6.933-4.536-16.228-2.594-20.765 4.34-4.535 6.934-2.592 16.231 4.341 20.766z" fill="#ffd321"/><g><g fill="#ff9d21"><path d="m255.872 87.946c2.612.085 5.443 1.059 7.214 1.943 1.051.525 2.183 1.199 3.586 2.117 8.257 5.401 19.899 1.068 22.63-8.398 1.804-6.255-.761-13.145-6.206-16.707-2.642-1.728-5.07-3.118-7.398-4.241-1.588-.819-3.409-1.62-5.427-2.324-.477-7.661-6.687-13.769-14.4-14.049v41.659z"/><path d="m269.9 102.734c-4.366-1.544-8.724-3.15-12.936-5.082-.309-.142-.681-.296-1.092-.465v32.379c1.344.495 2.689.979 4.03 1.453 2.478.876 5.226 2.456 4.473 6.937-.465 2.765-2.779 7.386-8.503 7.751v42.763c8.028-.291 14.447-6.891 14.447-14.99v-.774c12.172-5.067 21.338-16.081 23.64-29.777 3.009-17.892-6.66-34.045-24.059-40.195z"/></g></g><path d="m315.636 435.032-43.652-88.456c-.077-.157-.158-.313-.241-.468-3.038-5.647-9.04-9.153-15.668-9.153h-.021c-.061 0-.121.001-.182.002v45.068l11.311 22.616h-11.311v30h26.116l6.745 13.667c2.613 5.295 7.932 8.366 13.463 8.365 2.229 0 4.492-.499 6.626-1.552 7.43-3.665 10.48-12.66 6.814-20.089z" fill="#f6efea"/></g></svg>
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="creditwd" class="form-label text-warning">กรอกจำนวนเงินที่ต้องการฝาก</label>
                            <input type="text" class="form-control rounded-pill text-center mb-1" id="creditwd" placeholder="ระบุยอดที่ต้องการฝาก" bind:value={creditwd}>
                            {#if isMember}
                                <small class="text-white">ฝากขั้นต่ำ <span class="text-danger">{dataMember.dataGroup.min_deposit}</span> บาท</small>
                            {/if}
                        </div>
                        <div class="row">
                            {#if isbutton}
                            <div class="col-12 text-center d-grid gap-2"> 
                                <button type="button" class="btn btn-dark rounded-pill btn-gd" on:click={() => selectBankWithdrawCorePAY()}>ยืนยันฝากเงิน</button><br />
                            </div>
                            {:else}
                            <div class="col-12 text-center">
                                <Fa icon={faSpinner} size="2x" pulse class="text-white"/>
                            </div>
                            {/if}
                        </div>
                        
                    </div>
                </div>
                {/if}

                {#if isShowBank}
                {#if sectionBank}
                {#each bankBKList as item}
                <div class="card mt-3 bg-black">
                    <div class="card-body text-center">
                        <img src="./build/images/bank/{item.bank_code}.png" class="img-fluid" style="max-width: 30%;">
                        <h6 class="mt-4 text-warning">{item.bank_accname}</h6>
                        <h6 class="text-white">{item.bank_name}</h6>
                        <h5 class="mb-4 text-white">{item.bank_acc} 
                            
                            <Clipboard
                            text= {item.bank_acc}
                            let:copy
                            on:copy={() => {
                                console.log('Has Copied');
                                Swal.fire(`คัดลอกแล้ว`)
                            }}>
                            <span class="pointer" on:click={copy}><Fa icon={faCopy} size="1x"  pulse class="text-info " /></span>
                            </Clipboard>
                        
                        </h5>
                        <small class="text-info ">กดคัดลอกหมายเลขบัญขี แล้วโอนเงิน รอเครดิตเข้าไม่เกิน 30 วินาที</small>
                        
                    </div>
                </div>
                {/each}
                {/if}
                {/if}

                {#if isShowMulti}
                <div class="row">
                    <div class="col-12 pt-2">
                        <h6 class="text-warning">เลือกวิธีการโอนเงิน</h6>
                    </div>
                    <div class="col-6 p-2">
                        <div class="card mt-3 bg-black "  on:click={() => getSECPAYQRScan2()}>
                            <img src="./assets/icon/banknumber.png" class="img-fluid box-select-ch" alt="bak account" style="border-radius: 5px;">
                        </div>
                    </div>
                    <div class="col-6 p-2" on:click={() => getSECPAYQRScan()}>
                        <div class="card mt-3 bg-black">
                            <img src="./assets/icon/promptpay.png" class="img-fluid box-select-ch" alt="promptpay" style="border-radius: 5px;">
                        </div>
                    </div>
                    <div class="col-6 p-2">
                        <h6 class="text-white" on:click={() => getSECPAYQRScan2()}>บัญชีธนาคาร</h6>
                    </div>
                    <div class="col-6 p-2">
                        <h6 class="text-white" on:click={() => getSECPAYQRScan()}>คิวอาร์โค้ด</h6>
                    </div>
                </div>
                {/if}
            </div>
        </div>
    </div>
    {/if}

    {#if scactive.b =='active'}
    <div class="col-12 pb-5 mt-3" style="min-height: 500px">
        <div class="card mt-0 bg-xgrey">
            <div class="card-body text-center">
                {#each walletBKList as item}
                <div class="card mt-3 bg-black">
                    <div class="card-body text-center">
                        <img src="./build/images/bank/{item.bank_code}.png" class="img-fluid" style="max-width: 30%;">
                        <h6 class="mt-4 text-warning">{item.bank_accname}</h6>
                        <h6 class="text-white">{item.bank_name}</h6>
                    
                        <h5 class="mb-4 text-white">{item.bank_acc} 
                            <Clipboard
                            text= {item.bank_acc}
                            let:copy
                            on:copy={() => {
                                console.log('Has Copied');
                                Swal.fire(`คัดลอกแล้ว`)
                            }}>
                            <span class="pointer" on:click={copy}><Fa icon={faCopy} size="1x"  pulse class="text-info " /></span>
                            </Clipboard>
                        
                        </h5>
                        <small class="text-info ">กดคัดลอกหมายเลขบัญขี แล้วโอนเงิน รอเครดิตเข้าไม่เกิน 30 วินาที</small>
                        
                    </div>
                </div>
                {/each}
            </div>
        </div>
    </div>
    {/if}

    {#if scactive.c =='active'}
    <div class="col-12 pb-5 mt-3" style="min-height: 500px">
        <div class="card mt-0 bg-xgrey">
            <div class="card-body text-center text-white">
                <h6>กรุณาติดต่อเจ้าหน้าที่เพื่อสอบถามข้อมูล</h6>
            </div>
        </div>
    </div>
    {/if}

    {/if}
 
</div>
<Footer />
</div>
<div class="themes-home" style="display: none;">
    <div class="row mb-3 blog-deposits">
        <HeaderThemes/>
        <div class="col-12 text-center" ><h4  class="head-title ">เลือกช่องทางการฝากเงิน</h4></div>
        <div class="col-12 text-center mt-3" >
            <div class="card mt-0 bg-black">
                <div class="card-body text-center">
                    <div class="row text-white">
                        <div class="col-4 {scactive.a}" on:click={() => selectCh(1)}>
                            <span>บัญชีธนาคาร</span>
                            <div class="box-select-ch mt-2">
                                
                                <img src="./assets/icon/bankacc.png" class="img-fluid" alt="bak account">
                            </div>
                        </div>
                        <div class="col-4 {scactive.b}" on:click={() => selectCh(2)}>
                            <span>ทรูวอลเล็ท</span>
                            <div class="box-select-ch mt-2">
                                
                                <img src="./assets/icon/twalletacc.png" class="img-fluid" alt="truewallet account">
                            </div>
                        </div>
                        <div class="col-4 {scactive.c}"  on:click={() => selectCh(3)}>
                            <span>เงินดิจิทัล</span>
                            <div class="box-select-ch mt-2">
                                
                                <img src="./assets/icon/cryptoacc.png" class="img-fluid" alt="crypto currency account">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
        {#if loading}
        <div class="text-center mt-2" style="">
            <Fa icon={faSpinner} size="3x" pulse class="text-white"/>
        </div>
        {/if}
        {#if !loading}
    
        {#if scactive.a =='active'}
        <div class="col-12 pb-5 mt-3" style="min-height: 500px">
            <div class="card mt-0 bg-xgrey">
                <div class="card-body text-center">
    
                    {#if isGatewayCorepay}
                    <div class="card mt-2 bg-black">
                        <div class="card-body text-center pb-1">
                            <div class="row">
                                <div class="col-4"></div>
                                <div class="col-4 mb-2">
                                    <svg id="Capa_1" enable-background="new 0 0 511.744 511.744"  viewBox="0 0 511.744 511.744" class="img-fluid" xmlns="http://www.w3.org/2000/svg"><g><path d="m381.239 224.164c-48.956 0-88.785-39.829-88.785-88.785s39.829-88.785 88.785-88.785 88.784 39.829 88.784 88.785-39.828 88.785-88.784 88.785z" fill="#ff7d43"/><path d="m130.506 224.164c-48.956 0-88.785-39.829-88.785-88.785s39.829-88.785 88.785-88.785 88.784 39.829 88.784 88.785-39.828 88.785-88.784 88.785z" fill="#ff9d21"/><path d="m466.744 281.636h-421.744c-24.813 0-45 20.187-45 45v140.042c0 24.813 20.187 45 45 45h421.744c24.813 0 45-20.187 45-45v-140.042c0-24.813-20.186-45-45-45z" fill="#bee75e"/><path d="m466.744 281.636h-210.872v230.042h210.872c24.813 0 45-20.187 45-45v-140.042c0-24.813-20.186-45-45-45z" fill="#00cb75"/><path clip-rule="evenodd" d="m130.506 76.593c-32.414 0-58.785 26.371-58.785 58.785s26.371 58.785 58.785 58.785 58.784-26.371 58.784-58.785-26.37-58.785-58.784-58.785z" fill="#ffde46" fill-rule="evenodd"/><path clip-rule="evenodd" d="m381.239 76.593c-32.414 0-58.785 26.371-58.785 58.785s26.371 58.785 58.785 58.785 58.784-26.371 58.784-58.785-26.37-58.785-58.784-58.785z" fill="#ffcd00" fill-rule="evenodd"/><path d="m255.872 234.691c-64.687 0-117.312-52.626-117.312-117.313s52.626-117.312 117.312-117.312 117.312 52.626 117.312 117.312c.001 64.687-52.625 117.313-117.312 117.313z" fill="#ffd321"/><path d="m255.872.065v234.626c64.687 0 117.312-52.626 117.312-117.313.001-64.687-52.625-117.313-117.312-117.313z" fill="#ff9d21"/><circle clip-rule="evenodd" cx="255.872" cy="117.378" fill="#fff36c" fill-rule="evenodd" r="87.313"/><path clip-rule="evenodd" d="m255.872 30.065v174.626c48.145 0 87.312-39.168 87.312-87.313.001-48.145-39.167-87.313-87.312-87.313z" fill="#ffde46" fill-rule="evenodd"/><path d="m271.983 346.577c-.077-.157-.158-.313-.241-.468-3.038-5.647-9.04-9.153-15.668-9.153h-.021c-6.636.007-12.639 3.527-15.667 9.186-.069.129-.136.259-.201.39l-44.053 88.452c-3.693 7.416-.676 16.421 6.739 20.114 7.418 3.694 16.422.675 20.114-6.74l6.831-13.716h52.171l6.745 13.667c2.613 5.295 7.932 8.366 13.463 8.365 2.229 0 4.492-.499 6.626-1.552 7.43-3.666 10.479-12.66 6.813-20.089zm-27.224 58.064 11.113-22.616 11.311 22.616z" fill="#fff4f4"/><path d="m394.691 339.61c-6.941-4.519-16.234-2.556-20.755 4.388l-15.771 24.228-15.979-24.471c-4.529-6.938-13.825-8.888-20.761-4.359-6.937 4.529-8.888 13.824-4.358 20.761l26.106 39.981-.1 41.185c-.021 8.284 6.68 15.017 14.964 15.037h.037c8.267 0 14.979-6.692 14.999-14.963l.101-41.236 25.905-39.795c4.52-6.944 2.555-16.236-4.388-20.756z" fill="#f6efea"/><path d="m150.054 336.955h-24.817c-4.057 0-8.059 1.719-10.856 4.657-2.621 2.753-4.144 6.539-4.144 10.343v89.127c0 8.284 6.716 15 15 15s15-6.716 15-15v-23.792c3.791-.017 7.462-.031 9.817-.031 22.411 0 40.644-18.012 40.644-40.152s-18.233-40.152-40.644-40.152zm0 50.304c-2.376 0-5.987.013-9.725.03-.018-3.938-.031-7.758-.031-10.182 0-2.101-.008-6.02-.019-10.152h9.774c5.77 0 10.644 4.649 10.644 10.152s-4.874 10.152-10.643 10.152z" fill="#fff4f4"/><path d="m224.041 167.073c6.129 4.01 11.119 6.223 16.329 7.408.517 7.815 7.003 13.999 14.949 13.999 8.284 0 15-6.716 15-15v-.774c12.172-5.067 21.338-16.081 23.64-29.777 3.009-17.892-6.66-34.045-24.059-40.195-4.366-1.544-8.724-3.15-12.936-5.082-2.293-1.052-8.104-2.804-7.018-6.227 1.731-5.455 9.579-3.313 13.14-1.536 1.051.525 2.183 1.199 3.586 2.117 8.257 5.401 19.899 1.068 22.63-8.398 1.804-6.255-.761-13.145-6.206-16.707-2.642-1.728-5.07-3.118-7.398-4.241-1.588-.819-3.409-1.62-5.427-2.324-.488-7.844-6.986-14.059-14.952-14.059-8.284 0-15 6.716-15 15v.006c-10.237 4.396-17.723 13.777-19.89 25.274-2.247 11.926 1.769 23.578 10.479 30.409 7.755 6.083 18.518 10.349 28.994 14.052 2.478.876 5.226 2.456 4.473 6.937-.482 2.868-2.953 7.733-9.155 7.774-7.783.045-9.274-.177-14.755-3.762-6.933-4.536-16.228-2.594-20.765 4.34-4.535 6.934-2.592 16.231 4.341 20.766z" fill="#ffd321"/><g><g fill="#ff9d21"><path d="m255.872 87.946c2.612.085 5.443 1.059 7.214 1.943 1.051.525 2.183 1.199 3.586 2.117 8.257 5.401 19.899 1.068 22.63-8.398 1.804-6.255-.761-13.145-6.206-16.707-2.642-1.728-5.07-3.118-7.398-4.241-1.588-.819-3.409-1.62-5.427-2.324-.477-7.661-6.687-13.769-14.4-14.049v41.659z"/><path d="m269.9 102.734c-4.366-1.544-8.724-3.15-12.936-5.082-.309-.142-.681-.296-1.092-.465v32.379c1.344.495 2.689.979 4.03 1.453 2.478.876 5.226 2.456 4.473 6.937-.465 2.765-2.779 7.386-8.503 7.751v42.763c8.028-.291 14.447-6.891 14.447-14.99v-.774c12.172-5.067 21.338-16.081 23.64-29.777 3.009-17.892-6.66-34.045-24.059-40.195z"/></g></g><path d="m315.636 435.032-43.652-88.456c-.077-.157-.158-.313-.241-.468-3.038-5.647-9.04-9.153-15.668-9.153h-.021c-.061 0-.121.001-.182.002v45.068l11.311 22.616h-11.311v30h26.116l6.745 13.667c2.613 5.295 7.932 8.366 13.463 8.365 2.229 0 4.492-.499 6.626-1.552 7.43-3.665 10.48-12.66 6.814-20.089z" fill="#f6efea"/></g></svg>
                                </div>
                            </div>
                            <div class="mb-3">
                                <label for="creditwd" class="form-label text-warning">กรอกจำนวนเงินที่ต้องการฝาก</label>
                                <input type="text" class="form-control rounded-pill text-center mb-1" id="creditwd" placeholder="ระบุยอดที่ต้องการฝาก" bind:value={creditwd}>
                                {#if isMember}
                                    <small class="text-white">ฝากขั้นต่ำ <span class="text-danger">{dataMember.dataGroup.min_deposit}</span> บาท</small>
                                {/if}
                            </div>
                            <div class="row">
                                {#if isbutton}
                                <div class="col-12 text-center d-grid gap-2"> 
                                    <button type="button" class="btn btn-dark rounded-pill btn-gd" on:click={() => selectBankWithdrawCorePAY()}>ยืนยันฝากเงิน</button><br />
                                </div>
                                {:else}
                                <div class="col-12 text-center">
                                    <Fa icon={faSpinner} size="2x" pulse class="text-white"/>
                                </div>
                                {/if}
                            </div>
                            
                        </div>
                    </div>
                    {/if}
    
                    {#if isShowBank}
                    {#if sectionBank}
                    {#each bankBKList as item}
                    <div class="card mt-3 bg-black">
                        <div class="card-body text-center">
                            <img src="./build/images/bank/{item.bank_code}.png" class="img-fluid" style="max-width: 30%;">
                            <h6 class="mt-4 text-warning">{item.bank_accname}</h6>
                            <h6 class="text-white">{item.bank_name}</h6>
                            <h5 class="mb-4 text-white">{item.bank_acc} 
                                
                                <Clipboard
                                text= {item.bank_acc}
                                let:copy
                                on:copy={() => {
                                    console.log('Has Copied');
                                    Swal.fire(`คัดลอกแล้ว`)
                                }}>
                                <span class="pointer" on:click={copy}><Fa icon={faCopy} size="1x"  pulse class="text-info " /></span>
                                </Clipboard>
                            
                            </h5>
                            <small class="text-info ">กดคัดลอกหมายเลขบัญขี แล้วโอนเงิน รอเครดิตเข้าไม่เกิน 30 วินาที</small>
                            
                        </div>
                    </div>
                    {/each}
                    {/if}
                    {/if}

                    {#if isShowMulti}
                    <div class="row">
                        <div class="col-12 pt-2">
                            <h6 class="text-warning">เลือกวิธีการโอนเงิน</h6>
                        </div>
                        <div class="col-6 p-2">
                            <div class="card mt-3 bg-black "  on:click={() => getSECPAYQRScan2()}>
                                <img src="./assets/icon/banknumber.png" class="img-fluid box-select-ch" alt="bak account" style="border-radius: 5px;">
                            </div>
                        </div>
                        <div class="col-6 p-2" on:click={() => getSECPAYQRScan()}>
                            <div class="card mt-3 bg-black">
                                <img src="./assets/icon/promptpay.png" class="img-fluid box-select-ch" alt="promptpay" style="border-radius: 5px;">
                            </div>
                        </div>
                        <div class="col-6 p-2">
                            <h6 class="text-white" on:click={() => getSECPAYQRScan2()}>บัญชีธนาคาร</h6>
                        </div>
                        <div class="col-6 p-2">
                            <h6 class="text-white" on:click={() => getSECPAYQRScan()}>คิวอาร์โค้ด</h6>
                        </div>
                    </div>
                    {/if}
    
                </div>
            </div>
        </div>
        {/if}
    
        {#if scactive.b =='active'}
        <div class="col-12 pb-5 mt-3" style="min-height: 500px">
            <div class="card mt-0 bg-xgrey">
                <div class="card-body text-center">
                    {#each walletBKList as item}
                    <div class="card mt-2 bg-black">
                        <div class="card-body text-center">
                            <img src="./build/images/bank/{item.bank_code}.png" class="img-fluid" style="max-width: 30%;">
                            <h6 class="mt-4 text-warning">{item.bank_accname}</h6>
                            <h6 class="text-white">{item.bank_name}</h6>
                        
                            <h5 class="mb-4 text-white">{item.bank_acc} 
                                <Clipboard
                                text= {item.bank_acc}
                                let:copy
                                on:copy={() => {
                                    console.log('Has Copied');
                                    Swal.fire(`คัดลอกแล้ว`)
                                }}>
                                <span class="pointer" on:click={copy}><Fa icon={faCopy} size="1x"  pulse class="text-info " /></span>
                                </Clipboard>
                            
                            </h5>
                            <small class="text-info ">กดคัดลอกหมายเลขบัญขี แล้วโอนเงิน รอเครดิตเข้าไม่เกิน 30 วินาที</small>
                            
                        </div>
                    </div>
                    {/each}
                </div>
            </div>
        </div>
        {/if}
    
        {#if scactive.c =='active'}
        <div class="col-12 pb-5 mt-3" style="min-height: 500px">
            <div class="card mt-0 bg-xgrey">
                <div class="card-body text-center text-white">
                    <h6>กรุณาติดต่อเจ้าหน้าที่เพื่อสอบถามข้อมูล</h6>
                </div>
            </div>
        </div>
        {/if}
    
        {/if}
    </div>
</div>
<div class="themes-home-section" style="display: none;display:flex;">

</div>
<div class="footer-themes" style="display: none;">
    <FooterThemes />
</div>
<style>
    .btn-gd{
        /* --bs-btn-padding-y:0.1rem; --bs-btn-padding-x:0.3rem; --bs-btn-font-size:0.6rem;
        font-weight: 300; */
    }
    .bg-dk{
        background-color: black;
    }
    .text-sm{
        font-weight: 300;
        font-size: 0.6rem;
    }
    .pointer{
        cursor: pointer;
    }
    .bg-black{
        background: #000000ad !important;
    }
    .box-select-ch{
        border: 1px solid grey;
        border-radius: 10%;
        cursor: pointer;
    }
    .box-select-ch:hover{
        /* border: 2px solid gold; */
        box-shadow: 0px 0px 10px 3px gold;
    }
    .active .box-select-ch{
        border: 1px solid gold;
        box-shadow: 0px 0px 10px 3px gold;
    }
    .active {
        color: gold;
    }
</style>